module.exports = __webpack_public_path__ + "img/yuanliaobaozhuang.4d92505a.png";